import React, { useState } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import {
  Container,
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Alert,
  Link,
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { authService } from '../services/authService';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated, isPortalUser } = useAuth();
  const [benutzername, setBenutzername] = useState('');
  const [passwort, setPasswort] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Redirect if already logged in
  React.useEffect(() => {
    if (isAuthenticated) {
      if (isPortalUser) {
        navigate('/portal');
      } else {
        navigate('/');
      }
    }
  }, [isAuthenticated, isPortalUser, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login({ benutzername, passwort });

      // Get the user to check if portal user
      const user = authService.getStoredUser();

      // Check for saved redirect URL from token expiration
      const redirectUrl = sessionStorage.getItem('redirectAfterLogin');
      if (redirectUrl) {
        sessionStorage.removeItem('redirectAfterLogin');
        navigate(redirectUrl);
      } else if (user?.istPortalBenutzer) {
        // Portal-Benutzer zum Portal weiterleiten
        navigate('/portal');
      } else {
        navigate('/');
      }
    } catch (err: any) {
      console.error('Login error:', err);
      setError(
        err.response?.data?.message ||
          'Login fehlgeschlagen. Bitte überprüfen Sie Ihre Zugangsdaten.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper elevation={3} sx={{ padding: 4, width: '100%' }}>
          {/* Skeena Logo */}
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <img
              src="/logo.svg"
              alt="Skeena Logo"
              style={{ height: '60px', maxWidth: '100%' }}
            />
          </Box>

          <Typography component="h1" variant="h5" align="center" gutterBottom>
            Anmelden
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="benutzername"
              label="Benutzername"
              name="benutzername"
              autoComplete="username"
              autoFocus
              value={benutzername}
              onChange={(e) => setBenutzername(e.target.value)}
              disabled={loading}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="passwort"
              label="Passwort"
              type="password"
              id="passwort"
              autoComplete="current-password"
              value={passwort}
              onChange={(e) => setPasswort(e.target.value)}
              disabled={loading}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={loading || !benutzername || !passwort}
            >
              {loading ? 'Anmelden...' : 'Anmelden'}
            </Button>
            <Box sx={{ textAlign: 'center' }}>
              <Link component={RouterLink} to="/register" variant="body2">
                Noch kein Konto? Registrieren
              </Link>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;
